export default "__VITE_ASSET__0c66769a__"